import styled from '@emotion/styled';
import { Dropdown, Flex, Menu, type MenuProps } from 'antd';
import type { FC, ReactNode } from 'react';
import { AccountInfo } from '../BasicComponents/AccountInfo/AccountInfo';

type Props = {
  isCollapsed: boolean;
  items: NonNullable<MenuProps['items']>;
  collapsedItems?: NonNullable<MenuProps['items']>;
  costCalcModal: ReactNode;
};

export const UserLinks: FC<Props> = ({ isCollapsed, items, collapsedItems, costCalcModal }) => {
  if (items.length === 0) return null;

  if (isCollapsed) {
    return (
      <Flex vertical>
        <Menu items={collapsedItems ?? items} mode="vertical" />
        {costCalcModal}
      </Flex>
    );
  }

  return (
    <>
      {/* The hook belongs on the child, not on Dropdown: antd 6 still declares a
          className prop but never applies it, and Dropdown has no DOM node of its own.
          The trigger child's className is cloned onto the rendered element. */}
      <Dropdown menu={{ items }} trigger={['click']}>
        <UserButton id="user" type="button" className="nav-dropdown-user">
          <AccountInfo />
        </UserButton>
      </Dropdown>
      {costCalcModal}
    </>
  );
};

const UserButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
`;
